import React, { Component } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { kotaFetchAll } from 'actions/kotaAction'
import { AvForm } from 'availity-reactstrap-validation'
import { disparitasHarga } from 'actions/dashboardAction'
import { resellerFetchAll } from 'actions/resellerAction'
import { supplierFetchAll } from 'actions/supplierAction'
import { commodityFetchAll } from 'actions/commodityAction'
import { consigneeFetchAll } from 'actions/consigneeAction'
import { Row, Col, Card, CardHeader, CardBody, Button, FormGroup, CardFooter, Pagination, PaginationItem, PaginationLink, Table } from 'reactstrap'

let isDefaultBarang = false
let isDefaultKotaAsal = false
let isDefaultKotaTujuan = false
let isDefaultConsignee = false
let isDefaultSupplier = false
let isDefaultReseller = false

class DisparitasHarga extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      barang_id: '',
      barang_label: '',
      kota_asal: '',
      kota_asal_label: '',
      kota_tujuan: '',
      kota_tujuan_label: '',
      consignee_id: '',
      consignee_label: '',
      supplier_id: '',
      supplier_label: '',
      reseller_id: '',
      reseller_label: '',
      tahunVal:null,
      tahun:[{value:'', label:'-- Tahun --'}]
    }

    this.selectBarang = this.selectBarang.bind(this)
    this.selectKotaAsal = this.selectKotaAsal.bind(this)
    this.selectKotaTujuan = this.selectKotaTujuan.bind(this)
    this.selectConsignee = this.selectConsignee.bind(this)
    this.selectSupplier = this.selectSupplier.bind(this)
    this.selectReseller = this.selectReseller.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 10
    }

    this.props.disparitasHarga(data)
    this.props.kotaFetchAll()
    this.props.commodityFetchAll()
    this.props.consigneeFetchAll()
    this.props.supplierFetchAll()
    this.props.resellerFetchAll()
  }

  componentWillUnmount() {
    isDefaultBarang = false
    isDefaultKotaAsal = false
    isDefaultKotaTujuan = false
    isDefaultConsignee = false
    isDefaultSupplier = false
    isDefaultReseller = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        barang_id: this.state.barang_id,
        kota_asal: this.state.kota_asal,
        kota_tujuan: this.state.kota_tujuan,
        consignee_id: this.state.consignee_id,
        supplier_id: this.state.supplier_id,
        reseller_id: this.state.reseller_id,
      }
      if(this.state.tahunVal !== null){
        data.tahun = this.state.tahunVal.value
      }else{
        delete data.tahun
      }
      
      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      this.props.disparitasHarga(data)
    }

    if (this.props.disparitasHargaIsSuccess !==  prevProps.disparitasHargaIsSuccess) {
      // this.setState({...this.state, tahunVal:null})
      if(this.props.disparitasHargaData !== null){
        let year = []
        this.props.disparitasHargaData.years.map((val,i) => {
          const y = {value:val.year, label:val.year}
          year.push(y)
        })
       this.setState({...this.state, tahun:year})
      }
    }
  }

  selectBarang(opt) {
    if (opt) {
      this.setState({
        barang_id: opt.value,
        barang_label: opt.label
      })
    } else {
      this.setState({
        barang_id: '',
        barang_label: ''
      })
    }
  }

  selectTahun = (opt) => {
    this.setState({tahunVal:opt})
  }

  selectKotaAsal(opt) {
    if (opt) {
      this.setState({
        kota_asal: opt.value,
        kota_asal_label: opt.label
      })
    } else {
      this.setState({
        kota_asal: '',
        kota_asal_label: ''
      })
    }
  }

  selectKotaTujuan(opt) {
    if (opt) {
      this.setState({
        kota_tujuan: opt.value,
        kota_tujuan_label: opt.label
      })
    } else {
      this.setState({
        kota_tujuan: '',
        kota_tujuan_label: ''
      })
    }
  }

  selectConsignee(opt) {
    if (opt) {
      this.setState({
        consignee_id: opt.value,
        consignee_label: opt.label
      })
    } else {
      this.setState({
        consignee_id: '',
        consignee_label: ''
      })
    }
  }

  selectSupplier(opt) {
    if (opt) {
      this.setState({
        supplier_id: opt.value,
        supplier_label: opt.label
      })
    } else {
      this.setState({
        supplier_id: '',
        supplier_label: ''
      })
    }
  }

  selectReseller(opt) {
    if (opt) {
      this.setState({
        reseller_id: opt.value,
        reseller_label: opt.label
      })
    } else {
      this.setState({
        reseller_id: '',
        reseller_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    if (this.state.barang_id) {
      values.barang = this.state.barang_id
      isDefaultBarang = true
    } else {
      delete values.barang_id
      isDefaultBarang = false
    }
    
    if(this.state.tahunVal !== null){
      values.tahun = this.state.tahunVal.value
    }else{
      delete values.tahun
    }

    if (this.state.kota_asal) {
      values.kota_asal = this.state.kota_asal
      isDefaultKotaAsal = true
    } else {
      delete values.kota_asal
      isDefaultKotaAsal = false
    }

    if (this.state.kota_tujuan) {
      values.kota_tujuan = this.state.kota_tujuan
      isDefaultKotaTujuan = true
    } else {
      delete values.kota_tujuan
      isDefaultKotaTujuan = false
    }

    if (this.state.consignee_id) {
      values.consignee_id = this.state.consignee_id
      isDefaultConsignee = true
    } else {
      delete values.consignee_id
      isDefaultConsignee = false
    }

    if (this.state.supplier_id) {
      values.supplier_id = this.state.supplier_id
      isDefaultSupplier = true
    } else {
      delete values.supplier_id
      isDefaultSupplier = false
    }

    if (this.state.reseller_id) {
      values.reseller_id = this.state.reseller_id
      isDefaultReseller = true
    } else {
      delete values.reseller_id
      isDefaultReseller = false
    }

    values.length = this.state.perPage

    this.props.disparitasHarga(values)
  }

  changeRupiah(bilangan) {
    var number_string = bilangan.toString(),
      sisa = number_string.length % 3,
      rupiah = number_string.substr(0, sisa),
      ribuan = number_string.substr(sisa).match(/\d{3}/g);

    if (ribuan) {
      let separator = sisa ? '.' : '';
      rupiah += separator + ribuan.join('.');
    }

    return rupiah
  }

  render() {
    if (this.props.disparitasHargaIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.disparitasHargaHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }

  renderData() {
    if (this.props.disparitasHargaIsSuccess) {
      let defaultValues = {
        barang_id: this.state.barang_id,
        barang_label: this.state.barang_label,
        kota_asal: this.state.kota_asal,
        kota_asal_label: this.state.kota_asal_label,
        kota_tujuan: this.state.kota_tujuan,
        kota_tujuan_label: this.state.kota_tujuan_label,
        consignee_id: this.state.consignee_id,
        consignee_label: this.state.consignee_label,
        supplier_id: this.state.supplier_id,
        supplier_label: this.state.supplier_label,
        reseller_id: this.state.reseller_id,
        reseller_label: this.state.reseller_label,
      }

      const prevPage = parseInt(this.props.disparitasHargaData.currentPage) - 1
      const nextPage = parseInt(this.props.disparitasHargaData.currentPage) + 1

      let curPage = this.props.disparitasHargaData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.disparitasHargaData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { barang_id } = this.state.barang_id
      const defaultValueBarang = { label: defaultValues.barang_label, value: defaultValues.barang_id }
      const { kota_asal } = this.state.kota_asal
      const defaultValueKotaAsal = { label: defaultValues.kota_asal_label, value: defaultValues.kota_asal }
      const { kota_tujuan } = this.state.kota_tujuan
      const defaultValueKotaTujuan = { label: defaultValues.kota_tujuan_label, value: defaultValues.kota_tujuan }
      const { consignee_id } = this.state.consignee_id
      const defaultValueConsignee = { label: defaultValues.consignee_label, value: defaultValues.consignee_id }
      const { supplier_id } = this.state.supplier_id
      const defaultValueSupplier = { label: defaultValues.supplier_label, value: defaultValues.supplier_id }
      const { reseller_id } = this.state.reseller_id
      const defaultValueReseller = { label: defaultValues.reseller_label, value: defaultValues.reseller_id }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Disparitas Harga</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  {this.props.commodityIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select
                          name="barang_id"
                          value={barang_id}
                          isClearable
                          placeholder="Nama barang..."
                          defaultValue={isDefaultBarang ? defaultValueBarang : false}
                          onChange={this.selectBarang}
                          options={this.props.commodity.commodities}
                          id="barang_id"
                          inputId="input_barang_id"
                          instanceId="instance_barang_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.disparitasHargaIsSuccess && 
                     <Col md="4">
                     <FormGroup>
                       <Select
                         name="tahun"
                         value={[this.state.tahunVal]}
                         isClearable
                         placeholder="Tahun..."
                        //  defaultValue={isDefaultBarang ? defaultValueBarang : false}
                         onChange={this.selectTahun}
                         options={this.state.tahun}
                         id="tahun_id"
                         inputId="input_tahun_id"
                         instanceId="instance_tahun_id"
                       />
                     </FormGroup>
                   </Col>
                  }
                  {this.props.consigneeIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select
                          name="consignee_id"
                          value={consignee_id}
                          isClearable
                          placeholder="Consignee..."
                          defaultValue={isDefaultConsignee ? defaultValueConsignee : false}
                          onChange={this.selectConsignee}
                          options={this.props.consigneeData.data}
                          id="consignee_id"
                          inputId="input_consignee_id"
                          instanceId="instance_consignee_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.supplierIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select
                          name="supplier_id"
                          value={supplier_id}
                          isClearable
                          placeholder="Supplier..."
                          defaultValue={isDefaultSupplier ? defaultValueSupplier : false}
                          onChange={this.selectSupplier}
                          options={this.props.supplierData.data}
                          id="supplier_id"
                          inputId="input_supplier_id"
                          instanceId="instance_supplier_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.resellerIsSuccess &&
                    <Col md="4">
                      <FormGroup>
                        <Select
                          name="reseller_id"
                          value={reseller_id}
                          isClearable
                          placeholder="Reseller..."
                          defaultValue={isDefaultReseller ? defaultValueReseller : false}
                          onChange={this.selectReseller}
                          options={this.props.resellerData.data}
                          id="reseller_id"
                          inputId="input_reseller_id"
                          instanceId="instance_reseller_id"
                        />
                      </FormGroup>
                    </Col>
                  }
                </Row>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      {this.props.kotaIsSuccess &&
                        <Select
                          name="kota_asal"
                          value={kota_asal}
                          isClearable
                          placeholder="Kota asal..."
                          defaultValue={isDefaultKotaAsal ? defaultValueKotaAsal : false}
                          onChange={this.selectKotaAsal}
                          options={this.props.kota.data}
                          id="kota_asal"
                          inputId="input_kota_asal"
                          instanceId="instance_kota_asal"
                        />
                      }
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      {this.props.kotaIsSuccess &&
                        <Select
                          name="kota_tujuan"
                          value={kota_tujuan}
                          isClearable
                          placeholder="Kota tujuan..."
                          defaultValue={isDefaultKotaTujuan ? defaultValueKotaTujuan : false}
                          onChange={this.selectKotaTujuan}
                          options={this.props.kota.data}
                          id="kota_tujuan"
                          inputId="input_kota_tujuan"
                          instanceId="instance_kota_tujuan"
                        />
                      }
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1"><i className="fa fa-search"></i><span>Proses </span></Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th className="text-center align-top">Nama Barang</th>
                    <th className="text-center align-top">Harga Satuan</th>
                    <th className="text-center align-top">Supplier</th>
                    <th className="text-center align-top">Kota Supplier</th>
                    <th className="text-center align-top">Consignee</th>
                    <th className="text-center align-top">Kota Consignee</th>
                    <th className="text-center align-top">Harga Jual Consignee</th>
                    <th className="text-center align-top">Reseller</th>
                    <th className="text-center align-top">Kota Reseller</th>
                    <th className="text-center align-top">Harga Jual Reseller</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.disparitasHargaData.data.map((item, idx) => (
                    <tr key={idx}>
                      <td className="text-center align-top">{item.nama_barang}</td>
                      <td className="text-center align-top">{item.harga_satuan && this.changeRupiah(item.harga_satuan)} /{item.satuan}</td>
                      <td className="text-center align-top">{item.supplier_name}</td>
                      <td className="text-center align-top">{item.supplier_kota}</td>
                      <td className="text-center align-top">{item.consignee_name}</td>
                      <td className="text-center align-top">{item.consignee_kota}</td>
                      <td className="text-center align-top">
                        {item.harga_satuan_consignee !== null ? this.changeRupiah(item.harga_satuan_consignee) + ' /' + item.satuan : '-'}
                      </td>
                      <td className="text-center align-top">{item.reseller_name}</td>
                      <td className="text-center align-top">{item.reseller_kota}</td>
                      <td className="text-center align-top">
                        {item.harga_satuan_jual !== null ? this.changeRupiah(item.harga_satuan_jual) + ' /' + item.satuan : '-'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.disparitasHargaData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.disparitasHargaData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.disparitasHargaData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.disparitasHargaData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.disparitasHargaData.pageTotal > 0 &&
                <p>Page: {this.props.disparitasHargaData.currentPage} of {this.props.disparitasHargaData.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div>
      )
    }
  }
}

DisparitasHarga.propTypes = {
  disparitasHargaIsSuccess: PropTypes.bool.isRequired,
  disparitasHargaHasError: PropTypes.bool.isRequired,
  disparitasHargaIsLoading: PropTypes.bool.isRequired,

  kotaIsSuccess: PropTypes.bool.isRequired,
  kotaHasError: PropTypes.bool.isRequired,
  kotaIsLoading: PropTypes.bool.isRequired,

  commodityIsSuccess: PropTypes.bool.isRequired,
  commodityHasError: PropTypes.bool.isRequired,
  commodityIsLoading: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    disparitasHargaData: state.dashboard.disparitasHargaData,
    disparitasHargaIsSuccess: state.dashboard.disparitasHargaSuccess,
    disparitasHargaHasError: state.dashboard.disparitasHargaError,
    disparitasHargaIsLoading: state.dashboard.disparitasHargaLoading,

    kota: state.kotas.kotas,
    kotaIsSuccess: state.kotas.kotaGetSuccess,
    kotaHasError: state.kotas.kotaGetError,
    kotaIsLoading: state.kotas.kotaGetLoading,

    commodity: state.commodities.commodities,
    commodityIsSuccess: state.commodities.commodityGetSuccess,
    commodityHasError: state.commodities.commodityGetError,
    commodityIsLoading: state.commodities.commodityGetLoading,

    consigneeData: state.consignees.consignees,
    consigneeIsSuccess: state.consignees.consigneeGetSuccess,
    consigneeHasError: state.consignees.consigneeGetError,
    consigneeIsLoading: state.consignees.consigneeGetLoading,

    supplierData: state.suppliers.suppliers,
    supplierIsSuccess: state.suppliers.supplierGetSuccess,
    supplierHasError: state.suppliers.supplierGetError,
    supplierIsLoading: state.suppliers.supplierGetLoading,

    resellerData: state.resellers.resellers,
    resellerIsSuccess: state.resellers.resellerGetSuccess,
    resellerHasError: state.resellers.resellerGetError,
    resellerIsLoading: state.resellers.resellerGetLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    disparitasHarga: (data) => dispatch(disparitasHarga(data)),
    kotaFetchAll: () => dispatch(kotaFetchAll()),
    commodityFetchAll: () => dispatch(commodityFetchAll()),
    consigneeFetchAll: () => dispatch(consigneeFetchAll()),
    supplierFetchAll: () => dispatch(supplierFetchAll()),
    resellerFetchAll: () => dispatch(resellerFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DisparitasHarga)